import { CircularProgress, Grid } from '@mui/material';
import React, { CSSProperties, PropsWithChildren } from 'react';

export function FullScreenCenter({ children }: PropsWithChildren<any>) {
  return (
    <Grid container spacing={0} direction="column" alignItems="center" justifyContent="center" style={{ minHeight: '100vh' }}>
      {children}
    </Grid>
  );
}

export function FullScreenLoadingComponent() {
  return (
    <FullScreenCenter>
      <CircularProgress />
    </FullScreenCenter>
  );
}

export function CenterContent({ children, style, className }: PropsWithChildren<{ style?: CSSProperties; className?: string }>) {
  return (
    <Grid container spacing={0} direction="column" alignItems="center" justifyContent="center" style={style} className={className}>
      {children}
    </Grid>
  );
}

export function VerticallyCenterContent({ children, style, className }: PropsWithChildren<{ style?: CSSProperties; className?: string }>) {
  return (
    <Grid container spacing={0} direction="row" alignItems="center" justifyContent="center" style={style} className={className}>
      {children}
    </Grid>
  );
}
